import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { IconButton } from '@calendly/ui/components/icon-button';
import { DeleteIcon, EditPencilIcon, SettingsMenuVerticalIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { useCreateBookingVerificationSettingsMutation, useDeleteBookingVerificationSettingsMutation } from './api';
import { resetSelectedEventTypes } from './slice';
const styledItemCss = "s160ehle";
const StyledItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(styledItemCss, props.className)} />);
const actionsCss = "a1gx5kvs";
const Actions = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(actionsCss, props.className)} />;
});
export const ActionsDropdown = ({
  userId,
  eventType,
  refetch
}) => {
  const dispatch = useDispatch();
  const [toggle, Dropdown, isExpanded] = useDropdown();
  const [createBookingVerificationSettings] = useCreateBookingVerificationSettingsMutation();
  const [deleteBookingVerificationSettings] = useDeleteBookingVerificationSettingsMutation();
  const onClick = async (mutationFn, params) => {
    await mutationFn(params);
    refetch();
    dispatch(resetSelectedEventTypes());
  };
  return <Actions>
      <IconButton size="small" aria-expanded={isExpanded} onClick={toggle} aria-label={I18n.t('publisher.components.table.action_menu')}>
        <SettingsMenuVerticalIcon />
      </IconButton>
      <Dropdown>
        <ViewportDropdownMenu>
          <StyledItem onClick={() => onClick(createBookingVerificationSettings, {
          userId,
          eventTypeUuids: [eventType.uuid],
          eventTypeIds: [eventType.id]
        })}>
            <EditPencilIcon />
            {I18n.t('booking.email_verification.enable_events')}
          </StyledItem>
          <StyledItem onClick={() => onClick(deleteBookingVerificationSettings, {
          userId,
          eventTypeUuids: [eventType.uuid],
          eventTypeIds: [eventType.id]
        })}>
            <DeleteIcon />
            {I18n.t('booking.email_verification.disable_events')}
          </StyledItem>
        </ViewportDropdownMenu>
      </Dropdown>
    </Actions>;
};

require("./actions_dropdown.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./actions_dropdown.js");